import React from 'react';

import './loadingIndicator.scss';

const LoadingIndicatorComponent: React.FunctionComponent = () => (
  <div
    style={{
      display: 'block',
      width: '32px',
      height: '32px',
      padding: '4px',
      borderRadius: '50%',
      color: '#4e75b9',
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    }}
    id="loadingIndicator"
  >
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <path
        fill="currentColor"
        d="M16 32c-8.822 0-16-7.178-16-16s7.178-16 16-16c0.552 0 1 0.447 1 1s-0.448 1-1 1c-7.72 0-14 6.28-14
        14s6.28 14 14 14 14-6.28 14-14c0-3.74-1.457-7.257-4.103-9.901-0.391-0.391-0.391-1.023 0-1.414s1.023-0.391
        1.414 0c3.024 3.022 4.689 7.041 4.689 11.315 0 8.822-7.178 16-16 16z"
      />
    </svg>
  </div>
);

export default LoadingIndicatorComponent;
